import { render } from "./FooterCentral.vue?vue&type=template&id=57c2b15c"
import script from "./FooterCentral.vue?vue&type=script&lang=js"
export * from "./FooterCentral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__